// @ts-nocheck
import React from 'react';

const OratoriaPage = () => {
  return (
    <section className="pt-2 pb-10">
      <div className="container md:px-[65px]">
        <div className="flex flex-col-reverse text-white md:flex-row">
          <div className="relative md:w-3/5 bg-[#A81414] md:h-[400px] px-6 py-2 md:p-8 md:rounded-tl-xl rounded-bl-xl max-md:rounded-br-xl">
            <h2 className="py-3 text-xl font-bold text-justify uppercase md:text-4xl hyphens-auto">Що таке ораторія?</h2>
            <div className="pt-3 pb-3 max-md:leading-5 md:pl-8 hyphens-auto">
              “Ораторія” (від лат. oratorium – місце молитви) – місце, де діти й молодь мають можливість весело і по-християнськи провести свій вільний час, навчитися чогось нового, зустрітися з друзями, перебуваючи у єдності з Богом.
            </div>
            <div className="pt-3 pb-3 md:pl-8 hyphens-auto max-md:leading-5">
              Ораторія, або “місце молитви”, – це основне виховно-душпастирське середовище Салезіян.
              Саме так це назвав Святий отець Іван Боско, засновник Салезіян, адже у 1841 році у схожому місці почав збирати бідних та знедолених юнаків для того, щоб наблизити їх до Бога, навчити їх якогось ремесла, дати знання, прихисток та батьківську любов.
              Ораторія є також виховною спільнотою, яка проявляє себе в людському та християнському середовищі, що характеризується значною присутністю салезіян та вихователів серед молоді через пропозиції щодо формації для різних вікових груп.
            </div>
          </div>
          <div className="relative md:w-2/5">
            <div class="hidden md:block absolute md:top-1/2 md:left-0 md:-translate-y-1/2 border-[#A81414]
              w-0 h-0
              border-t-[20px] border-b-[20px] border-l-[10px]
              md:border-t-[200px] md:border-b-[200px] md:border-l-[100px]
              border-t-transparent border-b-transparent border-l-red-600">
            </div>
            <div class="md:hidden block absolute bottom-0 md:left-0 md:-translate-y-1/2 border-[#A81414]
              w-0 h-0
              border-b-[30px] border-l-[calc(50vw-20px)] border-r-[calc(50vw-20px)]
              md:border-t-[200px] md:border-b-[200px] md:border-l-[100px]
              border-l-transparent border-r-transparent border-t-transparent border-t-red-600">
            </div>
            <img
              className="md:h-[400px] object-cover object-right rounded-tr-xl md:rounded-br-xl rounded-tl-xl md:rounded-tl-none"
              src="/images/oratoriapage.jpg"
              alt=""
            />
          </div>
        </div>
        <div className="flex flex-col items-center md:pl-16 md:flex-row">

          <div className="relative md:w-1/2">
            <div>
              <div className="pt-6 text-md">
                Ораторія у нашій традиції є:
              </div>
              <ul className="pl-6 list-disc">
                <li className="texl-md">домом, який гостинно приймає усіх;</li>
                <li className="texl-md">церквою, яка євангелізує;</li>
                <li className="texl-md">школою, яка готує до життя;</li>
                <li className="texl-md">подвір’ям для зустрічі з друзями.</li>
              </ul>
            </div>
            <div class="hidden md:block absolute top-1/2 right-0 -translate-y-1/2 border-[#A81414] 
              w-0 h-0
              border-t-[40px] border-b-[40px] border-r-[20px]
              border-t-transparent border-b-transparent border-l-red-600">
            </div>
          </div>
          <div className="max-md:mt-4 relative max-md:ml-[28px] md:w-2/3 bg-[#A81414] md:h-[80px] flex justify-center items-center px-8 rounded-tr-xl rounded-br-xl">
            <div class="md:hidden absolute top-1/2 -left-[22px] -translate-y-1/2 border-[#A81414] 
              w-0 h-0
              border-t-[42px] border-b-[42px] border-r-[22px]
              border-t-transparent border-b-transparent border-l-red-600">
            </div>
            <h3 className="text-[14px] items-center flex  justify text-white uppercase text- nt-bold hyphens-auto max-md:leading-4 max-md:py-[10px]">
              Перша ораторія в Україні почала діяти при церкві Покрови Пресвятої Богородиці у Львові одразу після відкриття храму.
            </h3>
          </div>
        </div>

        <h3 className="max-md:pb-3 py-6 text-xl md:text-4xl font-bold text-justify uppercase hyphens-auto text-[#A81414]">Аніматори Ораторії</h3>
        <div className="md:px-16">
          <ul className="flex flex-col gap-5 text-justify hyphens-auto ">
            <li>
              Спільнота салезіянських аніматорів – це хлопці та дівчата, які відчули у своєму житті покликання служити дітям, даруючи свій час, таланти. а передусім свою віру та цінності добрих християн та чесних громадян. Спільнота аніматорів також потребує бути формованою. Через це кожного місяця відбуваються одноденні курси аніматорів, а також є пропозиції більш поглибленої формації, яка відбувається протягом трьох днів, і щотижневих зустрічей, які називаються РЕЗУМ (зустрічі християнської молоді), які слідують програмі напрацьованій душпастирською комісією Провінції.
            </li>
          </ul>
        </div>
        <h3 className="max-md:pb-3  py-6 text-xl md:text-4xl font-bold text-justify uppercase hyphens-auto text-[#A81414]">Молодь для молоді "МСР"</h3>
        <div className="text-justify md:px-16 hyphens-auto">
          Після закінчення Курсів Салезіянського Аніматора молодь ораторії прагне продовжувати бути в середовищі, яке для неї є рідним домом та колискою формації.
          Спільнота «молодь для молоді» є гарною можливістю бути тим продовженням, де старша молодь проходить постійну формацію, зростаючи і утверджуючись як добрі християни і чесні громадяни у перспективі виховання отця Боско.
          Це молодь, яка допомагає вести пасторальні напрямки в ораторії, стаючи провідниками, та надихає харизмою цілу структуру. Її завданням є передати цінності ораторії молодим поколінням.
          А також долучається до напрацювання виховно-душпастирських пропозицій.
        </div>
        <div className="pb-8 text-justify md:px-16 hyphens-auto">
          Основним напрямом розвитку цієї молоді є участь у Молодіжному Салезіянському Русі (МСР), тобто відчувати себе великою салезіянською родиною, незалежно від того, в якій структурі ти виховувався.
        </div>
        <div className="flex">
          <div className="relative w-[90%] md:w-2/5 bg-[#A81414] h-[80px] flex justify-start items-center pl-[24px] md:pl-8 rounded-tl-xl rounded-bl-xl">
            <h3 className="text-2xl text-justify text-white uppercase md:text-4xl nt-bold hyphens-auto">Ораторії в Україні</h3>
          </div>
          <div className="relative md:w-3/5">
            <div class="absolute top-1/2 left-0 -translate-y-1/2 border-[#A81414]
              w-0 h-0
              border-t-[40px] border-b-[40px] border-l-[20px]
              border-t-transparent border-b-transparent border-l-red-600">
            </div>
          </div>
        </div>
        <div className="flex flex-col justify-between py-4 md:px-16 md:flex-row">
          <div className="">
            <div className="text-[#A81414] font-bold pt-2 text-lg md:text-xl">
              ОРАТОРІЯ СВЯТОГО ДОМІНІКА САВІО
            </div>
            <div className="flex my-2 max-md:ml-4">
              <div className="flex md:hidden border-[2px] border-[#A81414] mr-6">
              </div>
              <div>
                <div className="py-3">
                  Відповідальний: Отець Тарас Милян, СДБ
                </div>
                <div className="">
                  Вул. Личаківська, 175
                </div>
                <div className="">
                  Львів
                </div>
              </div>
            </div>
          </div>
          <div className="hidden md:flex border-[2px] border-[#A81414]">
          </div>
          <div className="">
            <div className="text-[#A81414] font-bold pt-2 text-lg md:text-xl">
              ОРАТОРІЯ СВЯТОГО ІВАНА БОСКО
            </div>
            <div className="flex my-2 max-md:ml-4">
              <div className="flex md:hidden border-[2px] border-[#A81414] mr-6">
              </div>
              <div>
                <div className="py-3">
                  Відповідальний: Отець Григорій Швед, СДБ
                </div>
                <div className="">
                  Вул. Галицька, 13 Б
                </div>
                <div className="">
                  Винники
                </div>
              </div>
            </div>
          </div>
          <div className="hidden md:flex border-[2px] border-[#A81414]">
          </div>
          <div className="">
            <div className="text-[#A81414] font-bold pt-2 text-lg md:text-xl">
              ОРАТОРІЯ СВЯТОГО ІВАНА БОСКО
            </div>
            <div className="flex my-2 max-md:ml-4">
              <div className="flex md:hidden border-[2px] border-[#A81414] mr-6">
              </div>
              <div>
                <div className="py-3">
                  Відповідальний: Отець Андрій Платош, СДБ
                </div>
                <div className="">
                  Вул. Вакуленчука 34
                </div>
                <div className="">
                  Київ
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OratoriaPage;
